/**
 * Copies text. The Clipboard API exists only on secure origins (HTTPS or
 * localhost); on a LAN address over HTTP the selection fallback is used.
 */
export async function copyText(text: string): Promise<boolean> {
  const clipboard = navigator.clipboard as Clipboard | undefined;
  if (clipboard) {
    try {
      await clipboard.writeText(text);
      return true;
    } catch {
      // fall back below
    }
  }
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  // eslint-disable-next-line @typescript-eslint/no-deprecated -- the only option without the Clipboard API
  const ok = document.execCommand('copy');
  area.remove();
  return ok;
}
